import { useId } from 'react'

/**
 * The Kimene mark: a monogram K built as a routing junction — the routing
 * decision that is the whole point of the control plane, and the answer to the
 * question the name itself asks ("kime?" — to whom does this work route?). The
 * stem and two arms converge on a single bright node: the decision, the one
 * place that glows. It carries its own instrument-chip plate so it renders
 * identically in the app and as the browser-tab favicon (web/public/logo.svg —
 * keep the two in step).
 *
 * Decorative: it sits beside the wordmark, which carries the accessible name, so
 * the mark is aria-hidden. Gradient ids are per-instance because several marks
 * can share a page and duplicate SVG ids would cross-reference.
 */
export function Logo({ size = 28, className }: { size?: number; className?: string }) {
  const uid = useId().replace(/[^a-zA-Z0-9]/g, '')
  const plate = `kplate-${uid}`
  const glow = `kglow-${uid}`
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={plate} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#121a22" />
          <stop offset="1" stopColor="#0a0f15" />
        </linearGradient>
        <radialGradient id={glow} cx="11" cy="16" r="15" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#9ff2e0" />
          <stop offset="0.5" stopColor="#4dd8c0" />
          <stop offset="1" stopColor="#2f9585" />
        </radialGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="8.5" fill={`url(#${plate})`} stroke="#2a5a54" />
      <g
        fill="none"
        stroke={`url(#${glow})`}
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M11 7.5 V24.5" />
        <path d="M11 16 L21.5 8" />
        <path d="M11 16 L21.5 24" />
      </g>
      <rect
        x="6.9"
        y="11.9"
        width="8.2"
        height="8.2"
        rx="2"
        transform="rotate(45 11 16)"
        fill="#4dd8c0"
        opacity="0.3"
      />
      <rect
        x="8.05"
        y="13.05"
        width="5.9"
        height="5.9"
        rx="1.4"
        transform="rotate(45 11 16)"
        fill="#aef4e6"
      />
    </svg>
  )
}
